module.exports = __webpack_public_path__ + "static/media/lasrra-logo.14e7e050.png";